import { render } from "./SeoTopSection.vue?vue&type=template&id=42824ac4&scoped=true"
import script from "./SeoTopSection.vue?vue&type=script&lang=js"
export * from "./SeoTopSection.vue?vue&type=script&lang=js"

import "./SeoTopSection.vue?vue&type=style&index=0&id=42824ac4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42824ac4"]])

export default __exports__